// extracted by mini-css-extract-plugin
export default {"container":"TagPage_container__4AJBr","textContainer":"TagPage_textContainer__tw9EE","productCard":"TagPage_productCard__mKzf8"};